import React, { createContext, useContext } from 'react';
import { FourOhFourErrorPage } from '@sm/webassets';
import GoToURL from '~app/components/Survey/GoToURL';
import { UseSurveyErrorsReturn } from './types';
import { ErrorType } from './constants';

const SurveyErrorsContext = createContext<UseSurveyErrorsReturn>({
  errors: [],
  hasNoErrors: true,
  hasVersionChanged: false,
  hasNotFoundErrors: false,
  hasValidationErrors: false,
  hasRedirectErrors: false,
  reset: () => {},
  setError: () => {},
  setErrors: () => {},
  setErrorsById: () => {},
  getErrorMeta: () => ({}),
  getErrorsByType: () => [],
  getErrorsById: () => [],
  removeErrorsByType: () => {},
  removeErrorsById: () => {},
});

export function useSurveyErrorsContext(): UseSurveyErrorsReturn {
  return useContext(SurveyErrorsContext);
}

function SurveyErrorsProvider({
  children,
  ...api
}: { children: React.ReactNode } & UseSurveyErrorsReturn): React.ReactElement {
  if (api.hasNotFoundErrors) {
    return <FourOhFourErrorPage />;
  }
  if (api.hasRedirectErrors) {
    const { url } = api.getErrorMeta(ErrorType.REDIRECT);
    // Should this show an interim page for redirection with this component?
    // or, if not, this could become a pure function.
    return <GoToURL url={url} />;
  }

  return (
    <SurveyErrorsContext.Provider value={api}>
      <>{children}</>
    </SurveyErrorsContext.Provider>
  );
}

export default SurveyErrorsProvider;
